import Signup from './Signup';
import PostSignup from './PostSignup';

export default Signup;

export {
  PostSignup
}
